<template>
  <div>
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">纳税信息</div>
    </div>
    <div class="infotwo">
      <div class="infoitem">
        <div class="infotitle">纳税信用等级</div>
        <div class="infovalue">{{ detail.evaluationResult }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近1年营业收入</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.businessIncomeRec1Year }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近1年在建工程</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.constructionProjectRec1Year }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近1年固定资产</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.fixedAssetsRec1Year }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月税收违法次数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.inspectionTimesRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">最近一次实缴税距今月数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.lastSjjePurMonths }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近36个月最长连续零申报月数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.longestPersistNoSales36Months }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月应税销售收入为0的月份数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.noSalesMonths }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月连续零申报月数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.persistNoSales12Months }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月销售额同比</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.saleAmountRec12MonTB }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近6个月销售额同比增长率</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.saleAmountRec6MonTB }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近1年短期借款余额</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.shortTermLoanRec1Year }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">首次纳税申报日期</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxDeclareDateFirst }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近3个月纳税申报月份数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxDeclareMonthRec3Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近3个月增值税纳税同比</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxDeclareMonthRec3MonTB }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近6个月实缴金额为0的月份数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxDeclareSjje0AmtCnt6m }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月实缴金额同比</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxDeclareSjjeTb12m }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月0申报月数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxNoDeclareMonthRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近24月0申报月数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxPay0AmtCnt24m }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近24个月连续0申报月数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.taxPay0AmtContiCnt24m }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近1年资产总计</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalAssetsRec1Year }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月实缴金额合计</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalSjje12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近13-24个月纳税额</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalSjje13To24Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月增值税纳税额合计</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalTaxDeclareAmountRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月所得税纳税额合计</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalTaxIncomeAmountRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月应纳税额合计</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalTaxPayAmountRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月应税销售收入合计</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.totalTaxSalesAmountRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月滞纳金次数</div>
        <div class="infovalue">{{ detail.coreTaxFinanceIndex.znjTimesRec12Mon }}</div>
      </div>
    </div>

    <van-cell title="税务逾期和滞纳金是企业注册地区税局记录生成的(如有记录可自行登录当地电子税务局看到)，我方无法修改，报告内容仅供参考，不能用于任何用途。" :border="false" />
    <van-cell title="税收违法违章信息" :border="false" />
    <div class="datatable tableinfo2" style="margin-top: 0;">
      <div class="dataitem datahead">
        <div class="datacell">违法事实</div>
        <div class="datacell">登记日期</div>
        <div class="datacell">终止日期</div>
        <div class="datacell">案件状态</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.inspection">
        <div class="datacell">{{ item.illegal_fact }}</div>
        <div class="datacell">{{ item.r_data }}</div>
        <div class="datacell">{{ item.end_at }}</div>
        <div class="datacell">{{ item.status_tax_illegal }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object
    },
  }
}
</script>

<style></style>